import React from 'react';
import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

function AxisArrow({ isVisible, direction, insetBy = 2 }) {
  return direction === 'horizontal' ? (
    <HorizontalArrow isVisible={isVisible} insetBy={insetBy} />
  ) : (
    <VerticalArrow isVisible={isVisible} insetBy={insetBy} />
  );
}

function HorizontalArrow({ isVisible, insetBy }) {
  return (
    <OuterWrapper>
      <BackLayer>
        <HorizontalWrapper
          style={{
            '--stroke': 'var(--color-background)',
            '--stroke-width': '6px',
          }}
        >
          <div />
          <HorizontalLine
            style={{
              left: isVisible ? -4 : insetBy,
              right: isVisible ? 0 : insetBy,
            }}
          />
          <ArrowTip
            isVisible={isVisible}
            type="right"
            insetBy={insetBy}
          />
        </HorizontalWrapper>
      </BackLayer>
      <FrontLayer>
        <HorizontalWrapper
          style={{
            '--stroke': 'var(--color-text)',
            '--stroke-width': '2px',
          }}
        >
          <div />
          <HorizontalLine
            layout
            animate={{
              left: isVisible ? 0 : insetBy,
              right: isVisible ? 0 : insetBy,
            }}
          />
          <ArrowTip
            isVisible={isVisible}
            type="right"
            insetBy={insetBy}
          />
        </HorizontalWrapper>
      </FrontLayer>
    </OuterWrapper>
  );
}

function VerticalArrow({ isVisible, insetBy }) {
  return (
    <OuterWrapper>
      <BackLayer>
        <VerticalWrapper
          style={{
            '--stroke': 'var(--color-background)',
            '--stroke-width': '6px',
          }}
        >
          <div />
          <VerticalLine
            style={{
              top: isVisible ? -4 : insetBy,
              bottom: isVisible ? 0 : insetBy,
            }}
          />
          <ArrowTip
            isVisible={isVisible}
            type="bottom"
            insetBy={insetBy}
          />
        </VerticalWrapper>
      </BackLayer>
      <FrontLayer>
        <VerticalWrapper
          style={{
            '--stroke': 'var(--color-text)',
            '--stroke-width': '2px',
          }}
        >
          <div />
          <VerticalLine
            layout
            animate={{
              top: isVisible ? 0 : insetBy,
              bottom: isVisible ? 0 : insetBy,
            }}
          />
          <ArrowTip
            isVisible={isVisible}
            type="bottom"
            insetBy={insetBy}
          />
        </VerticalWrapper>
      </FrontLayer>
    </OuterWrapper>
  );
}

const ArrowTip = React.memo(function ArrowTip({
  isVisible,
  type,
  insetBy,
}) {
  let d, x, y;

  if (type === 'left') {
    d = `
      M 8 0
      L 0 8
      L 8 16
    `;
    x = isVisible ? 0 : insetBy;
    y = 0;
  } else if (type === 'right') {
    d = `
      M 8 0
      L 16 8
      L 8 16
    `;
    x = isVisible ? 0 : -insetBy;
    y = 0;
  } else if (type === 'top') {
    d = `
      M 0 8
      L 8 0
      L 16 8
    `;
    x = 0;
    y = isVisible ? 0 : insetBy;
  } else if (type === 'bottom') {
    d = `
    M 0 8
    L 8 16
    L 16 8
    `;
    x = 0;
    y = isVisible ? 0 : -insetBy;
  }

  return (
    <ArrowSvg
      animate={{ x, y }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path d={d} strokeLinecap="round" strokeLinejoin="round" />
    </ArrowSvg>
  );
});

const OuterWrapper = styled.div`
  position: relative;
  height: 100%;
`;

const BackLayer = styled.div`
  position: absolute;
  inset: 0px;
  width: 100%;
  height: 100%;
`;
const FrontLayer = styled.div`
  position: relative;
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HorizontalWrapper = styled(Wrapper)`
  height: 16px;
`;

const VerticalWrapper = styled(Wrapper)`
  flex-direction: column;
  width: 16px;
  height: 100%;
`;

const Line = styled(motion.div)`
  position: absolute;
  inset: 0;
  margin: auto;
  background: var(--stroke);
`;

const HorizontalLine = styled(Line)`
  height: var(--stroke-width);
`;

const VerticalLine = styled(Line)`
  width: var(--stroke-width);
`;

const ArrowSvg = styled(motion.svg)`
  display: block;
  overflow: visible;
  fill: none;

  path {
    fill: none;
    stroke: var(--stroke);
    stroke-width: var(--stroke-width);
    vector-effect: non-scaling-stroke;
  }
`;

export default AxisArrow;
